import SurveysService from "../services/SurveysService";

const makeCSV = (matrix) => {
    let csv = '';
    matrix.forEach(array => {
        let formattedArray = array.map(element => {
            if((typeof element === 'string' || element instanceof String) && (element.includes(',') || element.includes('"'))){
                element = element.replaceAll('"', '""');
                element = '"'+ element +'"';
            }
            return element;
        });
        csv += formattedArray.join();
        csv += '\n';
    });
    return csv;
};

const makeSpssCode = (spssVars, multiples, surveyQuestionList) => {
    var spssMultiples = {};
    var qid = null;
    var spssCode = "* Encoding: UTF-8.\r\n";

    const inSurveyOrder = (orderList) => (a, b) => {
        if (a.localeCompare(b) === 0) return 0;
        return orderList.indexOf(a) < orderList.indexOf(b) ? -1 : 1;
    }
    Object.keys(spssVars) && Object.keys(spssVars)
        .sort(inSurveyOrder(surveyQuestionList))
        .forEach(question_id => {
        //if it seems to be a multiple answer question, prepare for syntax
        var matchesMultiple = question_id.match(/_0\d+(_answer)?$/);
        var labels = spssVars[question_id]['valueLabels'];

        if (!matchesMultiple) {
            spssCode += "VARIABLE LABELS " + question_id + " \"" + spssVars[question_id]['label'] + "\".\r\n";
            if (labels) {
                spssCode += "VALUE LABELS " + question_id;
                for (var label in labels) {
                    spssCode += "\r\n     " + label + " " + "'" + labels[label] + "'";
                }
                spssCode += ".\r\n";
            }
        } else {
            if (labels) {
                spssCode += "VARIABLE LABELS " + question_id + " \"" + labels[Object.keys(labels)[0]] + "\".\r\n";
                spssCode += "VALUE LABELS " + question_id + " 1'" + "Yes" + "'.\r\n";
            }

            qid = question_id.substring(0, question_id.indexOf(matchesMultiple[0]));
            //if it's a multiple question
            if (multiples.indexOf(qid) !== -1) {
                if (!spssMultiples[qid]) {
                    spssMultiples[qid] = {label: spssVars[question_id]['label'], arr: []};
                }
                spssMultiples[qid].arr.push(question_id);
            }
        }
    });

    //multiple questions group syntax
    if (Object.keys(spssMultiples).length !== 0) {
        for (qid in spssMultiples) {
            spssCode += "\r\n" + "MULT RESPONSE GROUPS=$" + qid + "_all '" + spssMultiples[qid].label + "' (" + spssMultiples[qid].arr.sort().join(" ") + " (1))";
            spssCode += "\r\n/FREQUENCIES=$" + qid + "_all.";
        }
    }
    return spssCode;
}

export const getCSV = (surveyId) => {
    return new Promise((resolve, reject) => {
        SurveysService.GetSurveyCsv(surveyId, null, function successCallback(response) {
            let data = response.data.answers;
            let csvData = null;

            if (data) {
                data[0].answers.push("Respondent ID");
                csvData = data.map(function (a) {
                    a.answers.push(a.userId);
                    return a.answers;
                });
            }
            const csvString = makeCSV(csvData);
            let link = document.createElement('a');
            link.setAttribute('download', "BubblyPolls_" + surveyId + ".csv");
            let linkData = "text/csv;charset=utf-8," + encodeURIComponent(csvString);
            link.href = "data:" + linkData;
            link.click();
            resolve();
        },
        function errorCallback(response) {
            reject();
        });
    });
};

export const getSPSSVars = (surveyId, multipleQuestions) => {
    return new Promise((resolve, reject) => {
        SurveysService.GetSurveyCsv(surveyId, null, function successCallback(response) {
            let spssVars = response.data.labels;
            const questionsList = (response.data.answers && response.data.answers[0])
                ? response.data.answers[0].answers : [];
            let spssCode = makeSpssCode(spssVars, multipleQuestions, questionsList);
    
            let link = document.createElement("a");
            link.setAttribute('download', "BubblyPolls_" + surveyId + ".txt");
            let data = "text/plain;charset=utf-8," + encodeURIComponent(spssCode);
            link.href = "data:" + data;
            link.click();
            resolve();
        },
        function errorCallback(response) {
            reject();
        });
    });
};

export const getPPT = (surveyId, chartsPayload) => {
    return new Promise((resolve, reject) => {
        SurveysService.exportPpt(chartsPayload, function successCallback(response) {
            let pptFile = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            });
            let pptFileUrl = URL.createObjectURL(pptFile);

            let link = document.createElement("a");
            link.setAttribute('download', "BubblyPolls_" + surveyId + ".pptx");
            link.href = pptFileUrl;
            link.click();
            window.URL.revokeObjectURL(pptFileUrl);
            resolve();
        },
        function errorCallback(response) {
            reject();
        });
    });
};
